import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { symptomsData } from '../symptoms-detail-info/data';
import { RestService } from '../services/rest.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SymptomsDetailInfoComponent } from '../symptoms-detail-info/symptoms-detail-info.component';
import { ResultsLoaderComponent } from '../full-results/results-loader/results-loader.component';
import { MatIconModule } from '@angular/material/icon';
import { Location } from "@angular/common";
import { TranslatePipe } from '../pipes/translate.pipe';
import { PageBackService } from '../services/page-back.service';

@Component({
  selector: 'app-full-results-symptoms',
  templateUrl: './full-results-symptoms.component.html',
  styleUrls: ['./full-results-symptoms.component.scss'],
  standalone: true,
  imports: [CommonModule,ResultsLoaderComponent,MatIconModule,TranslatePipe]
})
export class FullResultsSymptomsComponent implements OnDestroy {
  // B3: this view renders its own history back, so the nav's Back tab (the same
  // Location.back()) steps aside while it is on screen.
  private pageBack = inject(PageBackService);

  symptomsInfo = null;
  scanId: string;
  symptoms: string[];
  showLoader = true;

  dialog = inject(MatDialog);

  constructor(private route: ActivatedRoute,
    // private router : Router,
    private  location : Location,
    private restService: RestService) {
    this.scanId = this.route.snapshot.params['scanId'];

  }
  ngOnDestroy(): void {
    this.pageBack.release();
  }

  async ngOnInit() {
    this.pageBack.register();
    try {
      const response: any = await this.restService.request({
        path: `scan/${this.scanId}/symptoms`,
        method: 'GET'
      });
      if (response.data) {
        this.symptoms = response.data.symptoms;
        this.symptomsInfo = symptomsData.filter(item1 =>
          this.symptoms.some(item2 => item1.slug === item2)
        );
        this.showLoader = false;
      }
    } catch (error) {
      console.error('Failed to fetch Symptoms:', error);
    }
  }

  showSymptomsInfo(slug: string) {
    this.dialog.open(SymptomsDetailInfoComponent, {
      data: {
        details: this.symptomsInfo.filter(x => x.slug == slug),
        key: slug
      }
    })
  }
  back(){
    this.location.back();
  }

}
